import { SingleMessageType } from "DataTypes/Chat.type";
import { CheckNumber, CheckStringEmpty } from "Utils/Common";

export const msgFormatter: (res: any) => SingleMessageType = (res) => {
  return {
    attachmentUrl: CheckStringEmpty(res?.attachmentUrl ?? res?.AttachmentUrl),
    case: CheckStringEmpty(res?.case ?? res?.Case),
    caseId: CheckNumber(res?.caseId ?? res?.CaseId),
    fileName: CheckStringEmpty(res?.fileName ?? res?.FileName),
    isRead: res?.isRead ?? res?.IsRead,
    messageContent: CheckStringEmpty(res?.messageContent ?? res?.MessageContent),
    messageType: CheckStringEmpty(res?.messageType ?? res?.MessageType),
    pkChatMessage: CheckNumber(res?.pkChatMessage ?? res?.PkChatMessage),
    readAt: CheckStringEmpty(res?.readAt ?? res?.ReadAt),
    senderUser: res?.senderUser ?? res?.SenderUser,
    senderUserId: CheckNumber(res?.senderUserId ?? res?.SenderUserId),
    senderName: CheckStringEmpty(res?.senderName ?? res?.SenderName),
    timestamp: CheckStringEmpty(res?.timestamp ?? res?.Timestamp),
    isCallEnded: res?.isCallEnded ?? res?.IsCallEnded,
    callDuration: res?.callDuration ?? res?.CallDuration,
  };
};
